import React, { useState, useEffect } from "react";
import "./DocumentHeader.css";
import { useNavigate } from "react-router-dom";
import CustomizedTooltip from "../atoms/Tooltip/CustomizedTooltip";
import { AttachmentStatus, SubmissionStatus } from "../../services/constants/constants";
import { formattedReviewSeconds } from '../../services/utils/Helper'
import PacketTimer from "../packet-timer/PacketTimer";
import ReviewCompletedIcon from '../../assets/reviewCompletedIcon.svg'
import { hitlShouldShow } from "../../services/utils/Helper";

const DocumentHeader = (props) => {

  const {
    documentName, documentId, submissionId, extraction,
    documentType, confidenceScore, documentSubType, packetOwner,
    allowHitl, status, setIsReviewPaused, reviewTime, completeReview,
    allDocumentsLoaded, setReviewTime, setHidePausedWarning, shouldStartTimer,
    isReviewPaused,
  } = props;

  const [navigationDropdown, setNavigationDropdown] = useState([]);
  const [navigationDropdownValue, setNavigationDropdownValue] =
    useState(documentId);
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/home/file-submissions");
  };

  const handleChange = (event) => {
    if (event.target.value === submissionId) {
      setNavigationDropdownValue(event.target.value);
      const route = `/home/submissions/${submissionId}`;
      navigate(route, { state: { startTimer: !isReviewPaused } });
    } else {
      setNavigationDropdownValue(event.target.value);
      const route = `/home/submissions/${submissionId}/documents/${event.target.value}`;
      navigate(route, { state: { startTimer: !isReviewPaused } });
    }
  };

  const fetchDocumentName = () => {
    const temp = [];
    if (extraction) {
      extraction.header.forEach((value) => {
        let docType = "";
        if (value.status === AttachmentStatus.Processed) {
          if (value.sub_classification?.trim() === "") {
            docType = "Binder: ";
          } else if (value.sub_classification) {
            docType = `${value.sub_classification}: `;
          } else {
            docType = "";
          }
          const obj = {
            key: value.document_id,
            value: `${docType} ${value.document_name}`,
          };
          temp.push(obj);
        }
      });
      (
        (extraction.status === SubmissionStatus.Ready_for_comparison.toLowerCase()
          || extraction.status === SubmissionStatus.Reviewed.toLowerCase()
        ) &&
        extraction.is_valid_submission
      ) && (
          temp.push({
            key: submissionId,
            value: "Comparison View",
          })
        )
      setNavigationDropdown(temp);
    }
  };

  useEffect(() => {
    fetchDocumentName();
  }, [extraction]);

  return (
    <React.Fragment>
      <div className="doc-header">
        <div
          className="col-lg-6 col-md-6 col-sm-7"
          style={{ paddingLeft: "0.9rem" }}
        >
          <div
            style={{ cursor: "pointer" }}
            className="header-label-flex"
            onClick={() => goHome()}
          >
            <img src={"assets/images/left-arrow.svg"} alt="leftArrow" />
            <CustomizedTooltip text={documentName}>
              <span className="h3Medium heading-content truncateDocName" id="docName">
                {documentName}
              </span>
            </CustomizedTooltip>
          </div>

          <div className="h3Medium ml-4 mt-2" style={{ color: "#3C4C68" }}>
            {documentType}
            {documentSubType && (
              <>
                <span>&#x3A;&nbsp;</span>
                <span style={{ color: "#24B082" }}>{documentSubType}</span>
              </>
            )}
            <span> | Confidence Score: {confidenceScore}</span>
          </div>
        </div>
        <div
          className="col-lg-6 col-md-6 col-sm-6 status"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <span className="header-label-flex" style={{ marginRight: "0.5rem" }}>
            <>
              <span className="h3Regular" style={{ color: "#616E84" }}>
                viewing:{" "}
              </span>
              <select
                name="navigateDropdown"
                id="navigateDropdown"
                className="dropdown-navigation"
                value={navigationDropdownValue}
                onChange={handleChange}
              >
                {navigationDropdown.map((item) => (
                  <option
                    className="navigation-dropdown-option"
                    value={item.key}
                  >
                    {item.value}
                  </option>
                ))}
              </select>
            </>
          </span>
          {packetOwner && hitlShouldShow(allowHitl) && status?.toLowerCase() !== SubmissionStatus.Reviewed.toLowerCase() ? (
            <PacketTimer
              submissionId={submissionId}
              setIsReviewPaused={setIsReviewPaused}
              completeReview={completeReview}
              allDocumentsLoaded={allDocumentsLoaded}
              showCompleteReview={false}
              setReviewTime={setReviewTime}
              setHidePausedWarning={setHidePausedWarning}
              shouldStartTimer={shouldStartTimer}
            />
          ) :
            <React.Fragment>
              {
                status?.toLowerCase() === SubmissionStatus.Reviewed.toLowerCase() &&
                <div style={{ marginInline: '4px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={ReviewCompletedIcon} alt="check" />
                    <span style={{ color: '#2D4081', paddingLeft: '0.5rem' }} className="h3Medium">Review Completed!</span>
                  </div>
                  <div className="review-time">
                    {formattedReviewSeconds(reviewTime)}
                  </div>
                </div>
              }
            </React.Fragment>}
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(DocumentHeader);
